import { createHttpClient } from '@rs/http-client';
import { appRoutes } from '@rs/spec-app-api';

export const api = createHttpClient(appRoutes, {
	baseUrl: import.meta.env.VITE_API_BASE_URL ?? globalThis.location.origin,
});
